<template>
  <b-container fluid class="theme-red">
    <div class="page-header">
      <Navbar text="Support" />
    </div>

    <section>
      <h2>Need help?</h2>

      <p>
        Contact us:
      </p>

      <pre>
Don Harvey Jr.
+1 (615) 440-0543
donharveyjr@harvinar.com
      </pre>
    </section>
  </b-container>
</template>

<script>
import Navbar from "../Navigation/Navbar";

export default {
  name: "Support",
  components: {
    Navbar,
  },
};
</script>
